<template>
  <div class="error container">
    <div class="content-wrapper content">
      <h3 class="code">
        {{ errorCode }}
      </h3>
      <h1 class="title">
        {{ title }}
      </h1>
      <p
        v-if="subTitle"
        class="description"
      >
        {{ subTitle }}
      </p>
      <slot />
    </div>
    <div class="content-wrapper bobs-container">
      <div class="bobs">
        <img
          v-if="errorCode == 404"
          alt="Four oh four image"
          :src="FourOhFourImage"
        >
        <img
          v-if="errorCode == 404"
          alt="Random shipbob image"
          class="bob-image"
          :src="bobImage"
        >
      </div>
    </div>
  </div>
</template>

<script>

import FourOhFourImage from '@public/media/images/404.png';
import bobImage from '@public/media/images/404-robert-de-niro.jpg';

/**
 * Error base is a template wrapper for all error pages on ShipBob.
 */
export default {
  name: 'ErrorBase',
  props: {
    /**
     * Error code.
     */
    errorCode: {
      type: String,
      required: true,
    },
    /**
     * Title of the error to be displayed on the page.
     */
    title: {
      type: String,
      required: true,
    },
    /**
     * Any subtext for the error on the page.
     */
    subTitle: {
      type: String,
      default: undefined,
      required: false,
    },
  },
  data: () => ({
    bobImage,
    FourOhFourImage,
  }),
};
</script>

<style scoped lang="scss">
@import '@src/pages/Error/style/error-base.scss';
</style>
